import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CreateCasePopupComponent } from 'app/shared/components/create-case-popup/create-case-popup.component';
import { TitleHeaderComponent } from 'app/shared/components/title-header/title-header.component';
import { NeedHelpFormComponent } from 'app/shared/components/forms/need-help-form/need-help-form.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeamManagementFormComponent } from "../shared/components/forms/team-management-form/team-management-form.component";
import { HelpDocumentLibraryComponent } from "./help-document-library/help-document-library.component";
import { GlobalSearchComponent } from 'app/shared/components/global-search/global-search.component';
import { HelperService } from 'app/shared/services/helper.service';

@Component({
  selector: 'app-help-page',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NeedHelpFormComponent,
    TitleHeaderComponent,
    CommonModule,
    TranslateModule,
    CreateCasePopupComponent,
    TeamManagementFormComponent,
    HelpDocumentLibraryComponent,
    GlobalSearchComponent,
  ],
  templateUrl: './help-page.component.html',
  styleUrl: './help-page.component.scss'
})
export class HelpPageComponent implements OnInit {
  form!: FormGroup;
  isAdmin: boolean = true;

  constructor(private fb: FormBuilder, private helperService: HelperService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      needHelpContent: [''],
      newCustomerSiteContent: ['']
    });
  }

  openCreateCasePopup() {
    this.helperService.createCasePopoupVisible = true;
    this.helperService.isSidebar = false;
  }

}
